import {
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  useTheme,
} from "@mui/material";
import OrderRow from "./order-row";
import { StyledTableRow } from "./styles";
import TableHeader from "../table-header/index.js";

const OrderTable = ({
  orderData,
  filterData,
  handleRowClick,
  startIndex,
  iconColor,
  handleOpenFilter,
  type,
  roles,
  loading,
}) => {
  const theme = useTheme();
  const defaultColor = "#D13438";
  const primary_color = theme.palette?.primary?.main || defaultColor;
  const TableSchema = [
    {
      key: "sl_no",
      title: "SL NO",
      render: (item, index) => (
        <Typography
          fontSize="12px"
          color="#667085"
          fontWeight={400}
          fontFamily={"Poppins"}
        >
          {startIndex + index + 1}
        </Typography>
      ),
    },
    {
      key: "order_id",
      title: "ORDER ID",
      handleOpenFilter: handleOpenFilter,
      displayKey: "order_id",
    },
    {
      key: "sub_type",
      title: "TYPE",
      handleOpenFilter: handleOpenFilter,
      displayKey: "sub_type",
    },
    // Upstream provenance. Aggregator OMSes (Pipe17) report the originating
    // system in `source_channel` ("shopify", "NetSuite", "sps-DillardsDropship");
    // for direct providers the oms_provider IS the source, so order-row falls
    // back to it. The filter options are that same coalesced value, served by
    // control-tower's fetch-order-source.
    {
      key: "source_channel",
      title: "ORDER SOURCE",
      handleOpenFilter: handleOpenFilter,
      displayKey: "source_channel",
    },

    ...(roles?.find((x) => x.name === "Admin")
      ? [
          {
            key: "client_id",
            title: "CLIENT",
            handleOpenFilter: handleOpenFilter,
            displayKey: "client_id?.business_name",
          },
        ]
      : []),
    ...(type === "M2O"
      ? [
          {
            key: "asn_no",
            title: "PO NUMBER",
            handleOpenFilter: handleOpenFilter,
            displayKey: "asn_no",
          },
        ]
      : []),
    // {
    //   key: "customer.name",
    //   title: "CUSTOMER NAME",
    //   handleOpenFilter: handleOpenFilter,
    //   displayKey: "customer.name",
    // },
    // Provider-supplied order tags, in the slot the tracking number used to
    // occupy (the number is still on the order detail modal, paired with its
    // carrier tracking link). Filter options come from control-tower's
    // fetch-order-tags; selecting several tags matches an order carrying ANY
    // of them, since `tags` is an array and the query is a plain `$in`.
    {
      key: "tags",
      title: "TAGS",
      handleOpenFilter: handleOpenFilter,
      displayKey: "tags",
    },
    {
      key: "shipments.service",
      title: "SERVICE",
      handleOpenFilter: handleOpenFilter,
      displayKey: "shipments.service",
    },
    // Where the order shipped FROM, opposite the destination column below.
    // Reads `order.warehouse`, which control-tower's find hook populates on
    // every row; no filter, because the field has no filter-options endpoint
    // and a header icon that opens an empty list is worse than none.
    {
      key: "warehouse",
      title: "FULFILLMENT LOCATION",
      displayKey: "warehouse",
    },
    {
      key: "shipping_address.province",
      title: "CUSTOMER STATE",
      handleOpenFilter: handleOpenFilter,
      displayKey: "shipping_address.province",
    },
    {
      key: "order_date",
      title: "ORDER DATE",
      handleOpenFilter: handleOpenFilter,
      displayKey: "order_date",
    },
    ...(roles?.find((x) => x.name === "Admin")
      ? [
          {
            key: "shipments.shipment",
            title: "SHIPMENT",
            handleOpenFilter: handleOpenFilter,
            displayKey: "shipments.shipment",
          },
        ]
      : []),
    {
      key: "status",
      title: "STATUS",
      handleOpenFilter: handleOpenFilter,
      displayKey: "status",
    },
  ];

  return (
    <TableContainer
      sx={{
        // marginTop: 1,
        maxHeight: "100%",
        overflowY: "scroll",
        paddingInline: 0.4,
      }}
    >
      <Table
        stickyHeader
        aria-label="sticky table"
        sx={{ border: "1px solid var(--border-color)" }}
      >
        <TableHead
          sx={{
            backgroundColor: "var(--bg-paper)",
            "& th": {
              backgroundColor: "var(--bg-paper)",
              borderBottom: "1px solid var(--border-color)",
              fontWeight: 600,
            },
          }}
        >
          <StyledTableRow>
            {TableSchema.map((column) => (
              <TableHeader
                filterData={filterData}
                primary_color={primary_color}
                handleOpenFilter={column.handleOpenFilter}
                key={column.key}
                filterKey={column.key}
                title={column.title}
                renderTitle={column.renderTitle}
              />
            ))}
          </StyledTableRow>
        </TableHead>
        <TableBody>
          {loading
            ? [...Array(10)].map((_, rowIndex) => (
                <TableRow key={rowIndex}>
                  {[...Array(TableSchema.length)].map((_, colIndex) => (
                    <TableCell key={colIndex} sx={{ p: 2 }}>
                      <Skeleton variant="text" />
                    </TableCell>
                  ))}
                </TableRow>
              ))
            : orderData?.map((row, index) => (
                <OrderRow
                  key={`${row.order_id} + ${index}`}
                  row={row}
                  index={index}
                  startIndex={startIndex}
                  handleRowClick={handleRowClick}
                  roles={roles}
                />
              ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default OrderTable;
